export const getInitialState = () => ({
  keycloak: {
    preferred_username: '',
    email: '',
    name: '',
  },
  data: {
    id: '',
    name: '',
    birthDate: '',
    gender: '',
    biologicalSex: '',
    documents: {},
    addresses: [],
    contacts: [],
    maskedContacts: {
      mobilePhoneList: [],
      emailList: [],
    },
  },
});

export const state = getInitialState();
